<ui-auth-layout [showLanguageSelector]="false">
  <span class="auth-badge auth-badge--destructive">
    <ui-svg-icon svgIcon="shield-alert-cc" size="small"></ui-svg-icon>
    {{ 'authentication.access_denied_badge' | translate }}
  </span>

  <div class="auth-heading">
    <h1 class="auth-heading__title">{{ 'authentication.access_denied_title' | translate }}</h1>
    <p class="auth-heading__subtitle">{{ 'authentication.access_denied_subtitle' | translate }}</p>
  </div>

  <div class="auth-note" *ngIf="fromUrl$ | async as fromUrl">
    <p class="auth-note__text">
      {{ 'authentication.access_denied_from' | translate }}
      <code class="access-denied__path" data-testid="access-denied-from">{{ fromUrl }}</code>
    </p>
  </div>

  <ui-button
    type="primary"
    testId="access-denied-action"
    [label]="'authentication.access_denied_primary_action' | translate"
    [fullWidth]="true"
    (click)="goBack()"
  ></ui-button>
</ui-auth-layout>
